<div class="card" >
  @if (!child().isActivated && (selectedMarket$ | async)) {
    <div class="apps-div">
      @if (enableSchedules) {
        <div class="app-box" id="schedules-box">
          <a href="../schedules"><div><span class="d-none d-lg-block"><i class="fa-solid fa-calendar-days fa-5x"></i><br /></span>Schedules</div></a>
        </div>
      }
      @if (enableRecordables) {
        <div class="app-box d-xl-block d-none" id="recordables-box">
          <a href="../recordables"><div><span class="d-none d-lg-block"><i class="fas fa-clipboard-check fa-5x"></i><br /></span>Recordables</div></a>
        </div>
      }
      @if (enablePurchaseOrders) {
        <div class="app-box" id="epo-box">
          <a href="../purchaseorders"><div><span class="d-none d-lg-block"><i class="fas fa-dollar-sign fa-5x"></i><br /></span>Field Purchase Orders</div></a>
        </div>
      }
      @if (enableBWP) {
        <div class="app-box" id="bwp-box">
          <a href="{{bwpUrl}}"><div><span class="d-none d-lg-block"><i class="fas fa-home fa-5x"></i><br /></span>BWP</div></a>
        </div>
      }
       @if (enableBQA) {
        <div class="app-box" id="bqa-box">
          <a href="{{bqaUrl}}"><div><span class="d-none d-lg-block"><img src="assets/images/BQA-w.svg" height="60" width="100" /><br /></span>Build Quality Assurance</div></a>
        </div>
      }
      @if (enableService) {
        <div class="app-box" id="eservice-box">
          <a href="{{serviceUrl}}"><div><span class="d-none d-lg-block"><i class="fas fa-wrench fa-5x"></i><br /></span>D365 Service</div></a>
        </div>
      }
      @if (enableReport) {
        <div class="app-box" id="eservice-box">
          <a href="{{reportingUrl}}"><div><span class="d-none d-lg-block"><i class="fas fa-chart-pie fa-5x"></i><br /></span>IDEA Reports</div></a>
        </div>
      }
    </div>
  }
  <router-outlet />
</div>